import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import JobList from './views/JobList.vue'
import JobCreate from './views/JobCreate.vue'
import JobCreateByBookingNumber from './views/JobCreateByBookingNumber.vue'
import JobDetails from './views/JobDetails.vue'
import Success from './views/Success.vue'
import Report from './views/Report.vue'
import BookingNumber from './views/BookingNumber.vue'
import NotFoundComponent from './views/NotFoundComponent.vue'
import Login from './views/Login.vue'
import ForgotPassword from './views/ForgotPassword.vue'
import SignUp from './views/SignUp.vue'
import NProgress from 'nprogress'
import store from '@/store/store'

NProgress.configure({ showSpinner: false })

Vue.use(Router)

const initialJobList = async () => {
	const activeTab = 'new'
	store.dispatch('job/setActiveTab', {
		activeTab
	})
	store.dispatch('job/clearJobs')
	let job_status = activeTab
	let pageSize = 5
	let sortBy = 'rundate'
	let exclusiveStartKey = JSON.stringify({})

	NProgress.start()
	const query_type = 'jobspool'

	await store.dispatch('job/fetchJobs', {
		job_status,
		query_type,
		pageSize,
		sortBy,
		exclusiveStartKey
	})
	NProgress.done()
}

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/home',
			name: 'home',
			component: Home
		},
		{
			path: '/',
			name: 'login',
			component: Login,
			meta: {
				Auth: true
			}
		},
		{
			path: '/index.html',
			redirect: {
				name: 'login'
			}
		},
		{
			path: '/signup',
			name: 'sign-up',
			component: SignUp,
			meta: {
				Auth: true
			}
		},
		{
			path: '/forgotPassword',
			name: 'forgot-password',
			component: ForgotPassword,
			meta: {
				Auth: true
			},
			props: true
		},
		{
			path: '/jobList',
			name: 'job-list',
			component: JobList,
			props: true,
			meta: {
				keepAlive: true
			},
			beforeEnter: async (routeTo, routeFrom, next) => {
				if (routeFrom.name !== 'job-details') {
					routeTo.meta.keepAlive = false
					await initialJobList()
					routeTo.meta.keepAlive = true
				}
				next()
			}
		},
		{
			path: '/jobcreate',
			name: 'job-create',
			component: JobCreate
		},
		{
			path: '/jobCreateByBookingNumber',
			name: 'job-create-by-booking-number',
			component: JobCreateByBookingNumber,
			props: true,
			beforeEnter: async (routeTo, routeFrom, next) => {
				const jobParams = store.state.job.jobParams
				if (jobParams.publication_name) {
					next()
				} else {
					router.push({
						name: 'booking-number'
					})
				}
			}
		},
		{
			path: '/jobdetail/:job_id',
			name: 'job-details',
			component: JobDetails,
			props: true,
			beforeEnter: async (routeTo, routeFrom, next) => {
				try {
					const job_id = routeTo.params.job_id
					const pageSize = 1000
					const exclusivestartkey = JSON.stringify({})
					const job = await store.dispatch('job/getJob', {
						job_id
					})
					const staff_email = job.staff_email
					store.dispatch('post/clearPosts')
					console.log(job)
					await store.dispatch('post/getPosts', {
						job_id,
						pageSize,
						exclusivestartkey
					})
					const user = JSON.parse(sessionStorage.getItem('user'))
					const profile = user.profile
					const userEmail = user.email
					const activeTab = store.state.job.activeTab
					let isClearUnreadClientPost = false

					if (
						(activeTab !== 'jobspool' ||
							staff_email === userEmail) &&
						activeTab
					) {
						isClearUnreadClientPost = true
					}

					;(activeTab !== 'jobspool' || staff_email === userEmail) &&
						activeTab
					if (profile === 'Staff') {
						isClearUnreadClientPost &&
							(await store.dispatch('job/clearUnreadClientPost', {
								job_id
							}))
					} else {
						await store.dispatch('job/clearUnreadStaffPost', {
							job_id
						})
					}
					next()
				} catch (e) {
					next(false)
					NProgress.done()
					console.log(e)
				}
			}
		},
		{
			path: '/success',
			name: 'success',
			component: Success
		},
		{
			path: '/report',
			name: 'report',
			component: Report
		},
		{
			path: '/bookingNumber',
			name: 'booking-number',
			component: BookingNumber
		},
		{
			path: '/404',
			name: '404',
			component: NotFoundComponent,
			props: true
		},
		{
			path: '*',
			component: NotFoundComponent
		}
	],
	scrollBehavior(to, from, savedPosition) {
		if (to.name === 'job-details') {
			return { x: 0, y: 0 }
		} else if (
			savedPosition &&
			to.name === 'job-list' &&
			from.name === 'job-details'
		) {
			const ScrollY = savedPosition.y
			return { x: 0, y: ScrollY }
		} else if (
			!savedPosition &&
			to.name === 'job-list' &&
			from.name === 'job-details'
		) {
			initialJobList()
		}
	}
})

router.beforeEach((routeTo, routeFrom, next) => {
	const user = JSON.parse(sessionStorage.getItem('user'))
	const token = sessionStorage.getItem('token')
	const routeToName = routeTo.name
	const routeToPath = routeTo.path

	const isAuthPage =
		routeToName === 'login' ||
		routeToName === 'sign-up' ||
		routeToName === 'forgot-password'
	const isAuth = user && token ? true : false

	if (!isAuth && !isAuthPage) {
		store.dispatch('auth/addRouteToPath', {
			routeToPath
		})
		router.push({
			name: 'login'
		})
	} else {
		NProgress.start()
		console.log('start', routeTo.name)
		next()
	}
})

router.afterEach(() => {
	console.log('afterEach')
	NProgress.done()
})

export default router
